// // ==================================== Base Action ====================================================
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT'
export const SET_CURRENT_PRODUCT_ASIN = 'SET_CURRENT_PRODUCT_ASIN'
export const SET_CURRENT_GCLID_CURRENT_SEARCH = 'SET_CURRENT_GCLID_CURRENT_SEARCH'